import { Injectable } from '@angular/core';
import { ActionGenerator, IAction, IActionFactory } from '../interfaces';
import { CloseInvitationAction, EnableButtonAction, ShowProactiveChatAction } from '../common/actions';
import { InvitationService, NotificationService } from '.';

@Injectable()
export class ActionFactory implements IActionFactory {
    private actionsGenerator: Map<string, ActionGenerator>;

    constructor(
        private invitationService: InvitationService,
        private notificationService: NotificationService
    ) {
        this.actionsGenerator = new Map<string, ActionGenerator>();
        this.initActionRegistry();
    }

    private initActionRegistry() {
        this.addAction('EnableChatButton', () => new EnableButtonAction(this.notificationService));
        this.addAction('ShowProactiveChat', () => new ShowProactiveChatAction(this.invitationService, this.notificationService));
        this.addAction('CloseChatInvitation', () => new CloseInvitationAction(this.invitationService, this.notificationService));
    }

    public addAction(name: string, generator: ActionGenerator): void {
        this.actionsGenerator.set(name, generator);
    }

    public getAction(name: string): IAction {
        const generator = this.actionsGenerator.get(name);
        if (!generator) throw new Error(`Unsupported action "${name}"`);

        const action = generator();
        return action;
    }
}
